// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"22":"deviceList","285":"uploadImg","535":"login","637":"order","685":"register"}[chunkId] + "." + {"22":"783403a9","285":"99d2a035","535":"b01b33ea","637":"fedd64df","685":"9528d736"}[chunkId] + ".js";
};